import { ArrowBack, CopyAllOutlined } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  Button,
  CheckboxGroupInput,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
import React from "react";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import { useRefresh } from "react-admin";
const EditToolbar = (props: any) => {
  const { reset } = useFormContext();
  const { success, error, info } = useNotify();
  const { getValues, formState } = useFormContext();
  const isDirty = formState.isDirty;
  const refresh = useRefresh();

  const record = useRecordContext();
  const id = record?.id;
  const handleUndo = () => {
    reset();
    //set isDirty to false
    success("Changes have been cancel");
  };

  const saveData = () => {
    const reqUrl = "banks/actions/edit";

    const formData = isDirty ? getValues() : null;
    if (formData) {
      const saveFormData = {
        //application alerts
        sReceiveAppSubmitMail: formData.sReceiveAppSubmitMail || [],
        sReceiveAppFinalReviewMail: formData.sReceiveAppFinalReviewMail || [],
        sReceiveAppNotificationMail: formData.sReceiveAppNotificationMail || [],
        sReceiveAppAcceptedCounteredMail:
          formData.sReceiveAppAcceptedCounteredMail || [],
        sReceiveAppCompletedSignMail:
          formData.sReceiveAppCompletedSignMail || [],
        sReceiveAppBecomeActiveLoanMail:
          formData.sReceiveAppBecomeActiveLoanMail || [],
        sReceiveAppTemplatesChangedMail:
          formData.sReceiveAppTemplatesChangedMail || [],
        sReceiveAppValidatedMail: formData.sReceiveAppValidatedMail || [],
        //account alerts
        sReceiveAccountSubmitMail: formData.sReceiveAccountSubmitMail || [],
        sReceiveAccountNotificationMail:
          formData.sReceiveAccountNotificationMail || [],
        sReceiveAccountCompletedSignMail:
          formData.sReceiveAccountCompletedSignMail || [],
        sReceiveAccountTemplatesChangedMail:
          formData.sReceiveAccountTemplatesChangedMail || [],
        //business alerts
        sReceive_event_pmt_loan_mod_requested:
          formData.sReceive_event_pmt_loan_mod_requested || [],
        sReceive_event_application_switch_ach_complete:
          formData.sReceive_event_application_switch_ach_complete || [],
        sReceive_event_application_switch_ach:
          formData.sReceive_event_application_switch_ach || [],
        sReceive_event_pmt_customer_transfer_failed:
          formData.sReceive_event_pmt_customer_transfer_failed || [],
        sReceive_event_pmt_attention_failed_transfer:
          formData.sReceive_event_pmt_attention_failed_transfer || [],

        saveType: "user_alert",
      };
      // console.log(
      //   "saveFormData=========>",
      //   Object.keys(saveFormData).length,
      //   saveFormData
      // );
      sendRequest(reqUrl, { id: id, data: saveFormData }).then((res) => {
        if (res?.code == 200) {
          success("Saved successfully");
          reset(formData);
          refresh();
        } else {
          error("Error saving " + res?.message);
        }
      });
    } else {
      error("Error saving description: No data to save");
    }
  };
  return (
    <Box
      sx={{
        display: "block",
        mt: "2px",
        borderRadius: "0px",
        paddingTop: "0px",
      }}
    >
      <Toolbar
        {...props}
        sx={{
          background: "#fff",
          justifyContent: "space-between",
          // border: "1px solid red",
          borderTop: "1px solid #e0e0e0",
          padding: "0px",
          marginTop: "10px",
          "&.MuiToolbar-root.RaToolbar-root": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
        }}
      >
        <CustomButtonCancel label="Undo" onClick={handleUndo} />
        {/* <SaveButton /> */}
        <CustomButtonSave
          variant="contained"
          color="primary"
          onClick={saveData}
          disabled={!isDirty}
          sx={{
            width: "120px",
          }}
        />
      </Toolbar>
    </Box>
  );
};

const AlertsEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();
  if (!record) return <div>Loading...</div>;
  const CustomLanguageSettings = () => {
    const record = useRecordContext();
    let bankerList = [];
    if (record?.bankerList) {
      bankerList = record.bankerList.map((banker: any) => ({
        id: banker.id,
        name: banker.name + " (" + banker.email + ")",
        value: banker.id,
      }));
    }
    // console.log("bankerList", bankerList);
    if (bankerList) {
      return (
        <>
          {/* Grid 3 column */}
          <Grid container spacing={2}>
            <Grid item xs={4} sm={4} md={4}>
              <Typography variant="h2">Credit Application</Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Please the users who will receive each email alert
              </Typography>

              <CheckboxGroupInput
                source="sReceiveAppSubmitMail"
                label="1. When a new application has been submitted"
                defaultValue={record?.sReceiveAppSubmitMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppFinalReviewMail"
                label="2. When an application is ready for Final Review"
                defaultValue={record?.sReceiveAppFinalReviewMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppNotificationMail"
                label="3. When review has completed and the application is ready for Notification"
                defaultValue={record?.sReceiveAppNotificationMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppAcceptedCounteredMail"
                label="4. When applicant has accepted a countered application"
                defaultValue={record?.sReceiveAppAcceptedCounteredMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppCompletedSignMail"
                label="5. When applicant has completed signing of loan documents"
                defaultValue={record?.sReceiveAppCompletedSignMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppBecomeActiveLoanMail"
                label="6. When application has become an Active Loan"
                defaultValue={record?.sReceiveAppBecomeActiveLoanMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppTemplatesChangedMail"
                label="7. When application and loan templates have changed"
                defaultValue={record?.sReceiveAppTemplatesChangedMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAppValidatedMail"
                label="8. When application or applicant is verified by a 3rd party"
                defaultValue={record?.sReceiveAppValidatedMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <Typography variant="h2">Account Open</Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Please the users who will receive each email alert
              </Typography>
              <CheckboxGroupInput
                source="sReceiveAccountSubmitMail"
                label="1. When a new application has been submitted"
                defaultValue={record?.sReceiveAccountSubmitMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAccountNotificationMail"
                label="2. When review has completed and the application is ready for Notification"
                defaultValue={record?.sReceiveAccountNotificationMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAccountCompletedSignMail"
                label="3. When applicant has completed signing of account documents"
                defaultValue={record?.sReceiveAccountCompletedSignMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceiveAccountTemplatesChangedMail"
                label="4. When application and other templates have changed"
                defaultValue={record?.sReceiveAccountTemplatesChangedMail || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <Typography variant="h2">Loan Payment</Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Please the users who will receive each email alert
              </Typography>
              <CheckboxGroupInput
                source="sReceive_event_pmt_loan_mod_requested"
                label="1. Borrower Loan Modification Request"
                defaultValue={
                  // record?.sReceive_event_pmt_loan_mod_requested || []
                  record?.sReceive_event_pmt_loan_mod_requested || []
                }
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceive_event_application_switch_ach_complete"
                label="2. ACH Switch Completed"
                defaultValue={
                  // record?.sReceive_event_application_switch_ach_complete || []
                  record?.event_application_switch_ach_complete || []
                }
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceive_event_application_switch_ach"
                label="3. ACH Switch Requested"
                defaultValue={record?.event_application_switch_ach || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceive_event_pmt_customer_transfer_failed"
                label="4. ACH Payment Failed"
                defaultValue={record?.event_pmt_customer_transfer_failed || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
              <CheckboxGroupInput
                source="sReceive_event_pmt_attention_failed_transfer"
                label="5. ACH Processing Put On Hold"
                defaultValue={record?.event_pmt_attention_failed_transfer || []}
                readOnly={isEdit ? false : true}
                row={false}
                fullWidth
                choices={bankerList}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </>
      );
    } else {
      return <div>No user list available</div>;
    }
  };
  return (
    <SimpleForm toolbar={<EditToolbar />}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        <CustomLanguageSettings />
      </Box>
    </SimpleForm>
  );
};

const AlertsEdit = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Welcome"
      actions={<Actions />}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<AlertsEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default AlertsEdit;
